/**
 * Header Component — Global Premium Brand Identity
 * Refined typography + subtle luxury accents
 */
import { LanguageCurrencySelector } from './LanguageCurrencySelector';

export function Header({
  language,
  onLanguageChange,
  currency,
  onCurrencyChange,
  t,
  onCommunityClick
}) {
  return (
    <div className="flex items-start justify-between">
      {/* Brand Identity */}
      <div className="flex items-start gap-3.5">
        {/* Logo Mark - Refined */}
        <div className="relative">
          <div className="w-11 h-11 bg-luxury-charcoal rounded-xl flex items-center justify-center shadow-luxury">
            <span className="text-lg">✦</span>
          </div>
          <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-accent-gold rounded-full border-2 border-white" />
        </div>

        <div className="flex flex-col pt-0.5">
          {/* Brand Name - Editorial Style */}
          <h1 className="text-[22px] font-medium text-luxury-charcoal tracking-[-0.03em] leading-none font-display">
            {t('brandName')}
          </h1>
          {/* Tagline - Refined Typography */}
          <p className="text-[11px] text-neutral-400 font-medium tracking-[0.2em] mt-1.5 uppercase">
            {t('tagline')}
          </p>
        </div>
      </div>

      {/* Language & Currency Switcher */}
      <div className="pt-1">
        <LanguageCurrencySelector
          currentLang={language}
          onLangChange={onLanguageChange}
          currentCurrency={currency}
          onCurrencyChange={onCurrencyChange}
          t={t}
        />
        <button
          onClick={onCommunityClick}
          className="ml-2 p-2 text-neutral-400 hover:text-brand-500 transition-colors"
          title={language === 'th' ? 'ชุมชน & ข้อเสนอแนะ' : 'Community & Feedback'}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </button>
      </div>
    </div>
  );
}

export default Header;
